const LEASE_KEY_PREFIX = 'appv2.global_call_listener';
const HEARTBEAT_MS = 3000;
export const GLOBAL_CALL_LEASE_MS = HEARTBEAT_MS * 3;

const createOwnerId = () =>
    `${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;

export default class GlobalCallLeader {
    constructor(userId, onLeadershipChange, options = {}) {
        this.storage = options.storage || window.localStorage;
        this.windowObject = options.windowObject || window;
        this.now = options.now || Date.now;
        this.ownerId = options.ownerId || createOwnerId();
        this.key = `${LEASE_KEY_PREFIX}.${userId}`;
        this.onLeadershipChange = onLeadershipChange;
        this.isLeader = false;
        this.heartbeat = null;
    }

    start() {
        this.windowObject.addEventListener('storage', this.handleStorage);
        this.windowObject.addEventListener('beforeunload', this.stop);
        this.checkLeadership();
        this.heartbeat = this.windowObject.setInterval(
            this.checkLeadership,
            HEARTBEAT_MS
        );
    }

    readLease = () => {
        try {
            const raw = this.storage.getItem(this.key);
            return raw ? JSON.parse(raw) : null;
        } catch (error) {
            return null;
        }
    };

    writeLease = () => {
        this.storage.setItem(this.key, JSON.stringify({
            ownerId: this.ownerId,
            expiresAt: this.now() + GLOBAL_CALL_LEASE_MS,
        }));
    };

    setLeadership = isLeader => {
        if (this.isLeader === isLeader) return;
        this.isLeader = isLeader;
        this.onLeadershipChange(isLeader);
    };

    checkLeadership = () => {
        try {
            const lease = this.readLease();
            const canAcquire = !lease
                || lease.ownerId === this.ownerId
                || Number(lease.expiresAt) <= this.now();

            if (canAcquire) {
                this.writeLease();
                const confirmedLease = this.readLease();
                this.setLeadership(confirmedLease && confirmedLease.ownerId === this.ownerId);
                return;
            }

            this.setLeadership(false);
        } catch (error) {
            // If browser storage is unavailable, keep telephony working in this tab.
            this.setLeadership(true);
        }
    };

    handleStorage = event => {
        if (event.key === this.key) this.checkLeadership();
    };

    stop = (notify = true) => {
        if (this.heartbeat) {
            this.windowObject.clearInterval(this.heartbeat);
            this.heartbeat = null;
        }
        this.windowObject.removeEventListener('storage', this.handleStorage);
        this.windowObject.removeEventListener('beforeunload', this.stop);

        try {
            const lease = this.readLease();
            if (lease && lease.ownerId === this.ownerId) {
                this.storage.removeItem(this.key);
            }
        } catch (error) {
            // Nothing to release when storage is unavailable.
        }

        if (notify) {
            this.setLeadership(false);
        } else {
            this.isLeader = false;
        }
    };
}
